import { render, staticRenderFns } from "./CompareAgeGroupSelector.vue?vue&type=template&id=5c016e10&scoped=true&"
import script from "./CompareAgeGroupSelector.vue?vue&type=script&lang=ts&"
export * from "./CompareAgeGroupSelector.vue?vue&type=script&lang=ts&"
import style0 from "./CompareAgeGroupSelector.vue?vue&type=style&index=0&id=5c016e10&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c016e10",
  null
  
)

export default component.exports